import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ScrudgService } from '../base/scrudg/scrudg.service';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';

@Injectable({
    providedIn: 'root'
})

export class ResourceService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "resource");
    }

    public getAvatarFullPath = (path: string): string => {

        const result: string = this._apiBaseUrl + "blob/" + path.replace(/\//g, "%2F");

        return result;
    }
}
